import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Rightarrow from "../assets/icons/Rightarrow";
import Terrible from "../assets/icons/Terrible";
import Bad from "../assets/icons/Bad";
import Good from "../assets/icons/Good";
import Awesome from "../assets/icons/Awesome";
import Okay from "../assets/icons/Okay";

const Feedback = () => {
  const [selectedRating, setSelectedRating] = useState("");

  const handleRatingSelect = (rating) => {
    setSelectedRating(rating);
  };

  return (
    <React.Fragment>
      <section>
        <div className="wrapper">
          <div className="account_grid">
            <Sidebar />
            <div className="page-content feedback-page">
              <h2 className="page-content-title">Give Feedback for LoadInn</h2>
              <p className="para_common">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod.
              </p>

              <div className="rating-section">
                <div
                  className={`rating-item ${
                    selectedRating === "Terrible" ? "active" : ""
                  }`}
                  onClick={() => handleRatingSelect("Terrible")}
                >
                  <Terrible />
                  <span>Terrible</span>
                </div>
                <div
                  className={`rating-item ${
                    selectedRating === "Bad" ? "active" : ""
                  }`}
                  onClick={() => handleRatingSelect("Bad")}
                >
                  <Bad />
                  <span>Bad</span>
                </div>
                <div
                  className={`rating-item ${
                    selectedRating === "Okay" ? "active" : ""
                  }`}
                  onClick={() => handleRatingSelect("Okay")}
                >
                  <Okay />
                  <span>Okay</span>
                </div>
                <div
                  className={`rating-item ${
                    selectedRating === "Good" ? "active" : ""
                  }`}
                  onClick={() => handleRatingSelect("Good")}
                >
                  <Good />
                  <span>Good</span>
                </div>
                <div
                  className={`rating-item ${
                    selectedRating === "Awesome" ? "active" : ""
                  }`}
                  onClick={() => handleRatingSelect("Awesome")}
                >
                  <Awesome />
                  <span>Awesome</span>
                </div>
              </div>

              <form className="feedback-form">
                <label htmlFor="review">Give us feedback</label>
                <textarea
                  id="review"
                  rows={4}
                  placeholder="Write your review here"
                ></textarea>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ width: "fit-content" }}
                >
                  Submit <Rightarrow />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Feedback;
